<div fxFill fxLayout="column">
   <div
      kendoTooltip
      #tooltip="kendoTooltip"
      showOn="none"
      position="right"
      filter=".sam-logo"
      [tooltipTemplate]="systemMonitor"
      tooltipClass="tooltip-popup"
      class="sam-clickable"
      (click)="tooltip.toggle(sm)"
   >
      <div class="sam-logo" #sm>
         <img [class.failure-mode]="!(isCommunicationHealthy$ | async)" />
      </div>
   </div>
   <div fxLayout="column" fxFlex class="navigation-bar" [class.failure-mode]="!(isCommunicationHealthy$ | async)">
      <div
         fxLayoutAlign="start"
         fxLayout="Column"
         style="display: inline"
         fxFlex="0 0 auto"
         *ngIf="(openEmailWindows$ | async).length > 0"
      >
         <samweb-home-bar-item
            style="cursor: unset"
            [menuItemIcon]="emailSolidIcon"
            [menuStackedItemIcon]="(openEmailWindows$ | async).length == 1 ? null : emailIcon"
            [menuStackedItemClass]="emailAdditionalClass"
            [class.active]="isEmailListOpen$ | async"
            (mouseenter)="openEmailListDialog()"
            (mouseleave)="closeEmailListDialog()"
            #emailListPopupControl
            #emailListTooltipDirective="kendoTooltip"
            kendoTooltip
            showOn="none"
            position="right"
            [tooltipTemplate]="emailListDialog"
            tooltipClass="tooltip-email-list"
         ></samweb-home-bar-item>
      </div>

      <div
         fxLayoutAlign="start"
         fxLayout="Column"
         style="display: inline"
         fxFlex="0 0 auto"
         *ngIf="(directoryEntriesInEditing$ | async).length > 0"
      >
         <samweb-home-bar-item
            style="cursor: unset"
            [menuItemIcon]="directoryEditIcon"
            [class.active]="isDirectoryEditingListOpen$ | async"
            (mouseenter)="openDirectoryEditingList()"
            (mouseleave)="closeDirectoryEditingList()"
            #directoryEditingListPopupControl
            #directoryEditingListTooltipDirective="kendoTooltip"
            kendoTooltip
            showOn="none"
            position="right"
            [tooltipTemplate]="directoryEditingList"
            tooltipClass="tooltip-email-list"
         ></samweb-home-bar-item>
      </div>

      <div
         class="chat-item-container"
         fxLayoutAlign="start"
         fxLayout="Column"
         style="display: inline"
         fxFlex="0 0 auto"
         *ngIf="(openChats$ | async).length > 0"
      >
         <samweb-unread-messages-badge
            class="unread-chat-messages-badge"
            *ngIf="(numberOfUnreadChatMessages$ | async) > 0"
            [numberOfUnreadMessages]="numberOfUnreadChatMessages$"
            [showNumber]="false"
            #unreadChatMessagesBadge
         ></samweb-unread-messages-badge>

         <samweb-home-bar-item
            style="cursor: unset"
            [menuItemIcon]="chatSolidIcon"
            [menuStackedItemIcon]="(openChats$ | async).length == 1 ? null : chatIcon"
            [class.active]="isChatListOpen$ | async"
            (mouseenter)="toggleChatList()"
            #chatListPopupControl
            #chatListTooltipDirective="kendoTooltip"
            kendoTooltip
            showOn="none"
            position="right"
            [tooltipTemplate]="chatList"
            tooltipClass="tooltip-chat-list"
         ></samweb-home-bar-item>
      </div>

      <div fxFlex="1 1 auto" fxLayoutAlign="end" fxLayout="row">
         <div fxLayout="column" fxLayoutAlign="end center" style="width: 100%">
            <samweb-home-bar-item
               *ngIf="isBrickWallEditingEnabled$ | async"
               class="grouped-layout-item grouped-layout-top-line"
               (click)="stopBrickEditing(true)"
               [menuItemIcon]="applyEditIcon"
               [ngClass]="!(isSavingBrickWall$ | async) ? 'sam-pointer-disabled item-disabled k-i-loading' : ''"
               menuItemTranslationKey="navigation.homebar.edit_mode.save_button"
            >
            </samweb-home-bar-item>

            <samweb-home-bar-item
               *ngIf="isBrickWallEditingEnabled$ | async"
               class="grouped-layout-item"
               (click)="stopBrickEditing(false)"
               [menuItemIcon]="cancelEditIcon"
               menuItemTranslationKey="navigation.homebar.edit_mode.cancel_button"
               [ngClass]="!(isSavingBrickWall$ | async) ? 'sam-pointer-disabled item-disabled' : ''"
            >
            </samweb-home-bar-item>

            <samweb-home-bar-item
               *ngIf="isBrickWallEditingEnabled$ | async"
               class="grouped-layout-item"
               [menuItemIcon]="toggleBrickMenuIcon"
               (click)="toggleBrickMenu()"
               [class.active]="isBrickMenuOpen$ | async"
               [class.grouped-layout-top-line]="!(isBrickWallEditingEnabled$ | async)"
               [ngClass]="!(isSavingBrickWall$ | async) ? 'sam-pointer-disabled item-disabled' : ''"
               #addBricksMenuPopupControl
               #addBricksMenuTooltipDirective="kendoTooltip"
               kendoTooltip
               showOn="none"
               position="right"
               [tooltipTemplate]="addbrickDialog"
               tooltipClass="tooltip-popup"
               menuItemTranslationKey="navigation.homebar.edit_mode.add_brick_button"
            ></samweb-home-bar-item>

            <samweb-home-bar-item
               *ngIf="isFeatureEnabled$ | async"
               (click)="startBrickEditing()"
               [menuItemIcon]="toggleBrickLayoutIcon"
               [class.active]="isBrickWallEditingEnabled$ | async"
               [class.grouped-layout-item]="isBrickWallEditingEnabled$ | async"
               class="grouped-layout-bottom-line group-toggle-item no-toggle"
               menuItemTranslationKey="navigation.homebar.edit_mode.change_brick_wall_layout"
            ></samweb-home-bar-item>

            <samweb-home-bar-item
               [menuItemIcon]="settingsIcon"
               [class.active]="isGlobalSettingsDialogOpen$ | async"
               (click)="toggleGlobalSettings()"
               #globalSettingsPopupControl
               #globalSettingsTooltipDirective="kendoTooltip"
               kendoTooltip
               showOn="none"
               position="right"
               [tooltipTemplate]="globalSettingsDialog"
               tooltipClass="tooltip-popup"
               menuItemTranslationKey="navigation.homebar.settings"
            ></samweb-home-bar-item>

            <samweb-home-bar-item
               (click)="toggleSignOutDialog()"
               [class.active]="isSignOutDialogOpen$ | async"
               [menuItemIcon]="signOutIcon"
               kendoTooltip
               showOn="none"
               position="right"
               #signOutDialogPopupControl
               #signOutDialogTooltipDirective="kendoTooltip"
               [tooltipTemplate]="signOutDialog"
               tooltipClass="tooltip-popup"
               menuItemTranslationKey="navigation.homebar.logout_button"
               [ngClass]="(isLogoutDisabled$ | async) ? 'sam-pointer-disabled' : ''"
               [@toggleDisable]="(isLogoutDisabled$ | async) ? 'btn-disabled' : 'btn-enabled'"
            ></samweb-home-bar-item>
            <div class="version-info">{{ clientVersion.semVer }}</div>
         </div>
      </div>
   </div>
</div>

<ng-template #emailListDialog>
   <samweb-email-list-dialog fxFlexFill (mouseenter)="openEmailListDialog()" (mouseleave)="closeEmailListDialog()">
   </samweb-email-list-dialog>
</ng-template>

<ng-template #directoryEditingList>
   <kendo-listview
      class="dialog-list"
      [data]="directoryEntriesInEditing$ | async"
      (mouseenter)="openDirectoryEditingList()"
      (mouseleave)="closeDirectoryEditingList()"
   >
      <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
         <samweb-directory-editing-item [entry]="dataItem"> </samweb-directory-editing-item>
      </ng-template>
   </kendo-listview>
</ng-template>

<ng-template #chatList>
   <kendo-listview class="dialog-list" [data]="openChats$ | async" (mouseleave)="toggleChatList()">
      <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
         <samweb-chat-list-item [chatId]="dataItem"></samweb-chat-list-item>
      </ng-template>
   </kendo-listview>
</ng-template>

<ng-template #globalSettingsDialog>
   <samweb-global-settings></samweb-global-settings>
</ng-template>

<ng-template #addbrickDialog>
   <samweb-add-brick-dialog></samweb-add-brick-dialog>
</ng-template>

<ng-template #systemMonitor>
   <div [style.width]="'600px'" #sysMon>
      <samweb-system-monitor-overview></samweb-system-monitor-overview>
   </div>
</ng-template>

<ng-template #signOutDialog>
   <div (samwebOutsideClick)="closeSignOutDialog()">
      <samweb-sign-out-dialog></samweb-sign-out-dialog>
   </div>
</ng-template>
